import { getBadgeText } from "./getBadgeText";
import styles from "./index.css";
import { withTranslation } from "../../../../../translation";
import classnames from "classnames";
import PropTypes from "prop-types";

const ProductBadge = ({ className, labelledById, ...rest }) => {
  const badgeText = getBadgeText({ ...rest });

  return badgeText ? (
    <div
      id={labelledById}
      className={classnames(styles.productBadge, className)}
    >
      {badgeText}
    </div>
  ) : null;
};

ProductBadge.propTypes = {
  className: PropTypes.string,
  labelledById: PropTypes.string
};

export default withTranslation(ProductBadge);
